import { render, staticRenderFns } from "./message-robot-welcome.vue?vue&type=template&id=45ab90ff"
import script from "./message-robot-welcome.vue?vue&type=script&lang=ts"
export * from "./message-robot-welcome.vue?vue&type=script&lang=ts"
import style0 from "./message-robot-welcome.vue?vue&type=style&index=0&id=45ab90ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports